import type { RecordingListItem } from "../api/types";

export type SortKey = "newest" | "score";

/** Sort a copy of the list by newest-first, or by QC score (desc) then newest. */
export function sortRecordings(items: RecordingListItem[], sort: SortKey): RecordingListItem[] {
  return [...items].sort((a, b) => {
    if (sort === "score") {
      const sb = b.qc?.score ?? -1;
      const sa = a.qc?.score ?? -1;
      if (sb !== sa) return sb - sa;
    }
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });
}

export default function SortControl({
  sort,
  onChange,
}: {
  sort: SortKey;
  onChange: (s: SortKey) => void;
}) {
  return (
    <div className="sort-control">
      <span className="sort-label">Sort</span>
      <div className="seg">
        <button
          className={sort === "newest" ? "seg-btn active" : "seg-btn"}
          onClick={() => onChange("newest")}
        >
          Newest
        </button>
        <button
          className={sort === "score" ? "seg-btn active" : "seg-btn"}
          onClick={() => onChange("score")}
        >
          Score
        </button>
      </div>
    </div>
  );
}
